
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.73 17.169c-.917-.234-1.526-1.069-2.307-1.565-.61-.451-1.19-.975-1.816-1.386-.833.662-1.546 1.47-2.386 2.125-.97.447-1.323-.809-1.491-1.503-.388-1.265-.758-2.535-1.147-3.8-.682-.37-1.492-.54-2.227-.824C1.638 9.899.731 9.85.206 9.212-.461 8.307.639 7.575 1.42 7.36 6.444 5.221 11.448 3.034 16.484.93c1.042-.497 1.802.716 1.412 1.623-.887 4.557-1.739 9.122-2.637 13.677-.189.641-.873 1.05-1.529.94zm.448-.825c.613-.579.428-1.603.696-2.367.75-3.96 1.54-7.914 2.263-11.88.038-1.002-1.325.124-1.85.207C10.54 4.342 5.782 6.357 1.045 8.416c-.573.606 1.046.741 1.431.981l2.37.81c3.268-2.165 6.511-4.369 9.806-6.492 1.125.251-.25 1.306-.562 1.77-1.892 2.243-3.822 4.456-5.686 6.722.456.47 1.12.85 1.647 1.298 1.206.93 2.392 1.886 3.61 2.8.156.082.351.113.517.039zm-7.394-1.486c.236-.934.366-1.911.673-2.815 1.642-1.975 3.347-3.899 4.97-5.889C10.076 7.701 7.71 9.234 5.4 10.84c.35 1.395.836 2.8 1.237 4.2.122.34.09-.175.146-.181zm1.453-.517c.576-.38.864-.807.092-1.118-.595-.416-.431.975-.657 1.398-.247.67.442-.246.565-.28z"}})])
          )
        }
      }
    